import * as React from 'react';
import MultiClamp from 'react-multi-clamp';

import Text from 'crehana-ui/Text';
import { secondaryMain } from 'crehana-ui/styles/colors';
import HeartBorderLight from 'crehana-icons/HeartBorderLight';

import { ProductsContext } from 'Jsx/ContextApis/Products';
import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import userActivity from 'Utils/userActivity';

const Title: React.FC<Partial<CourseCardProps>> = props => {
  const { wishlistState, toggleWishlistItem } = React.useContext(
    ProductsContext,
  );
  const {
    title,
    url,
    clickTitleHandler,
    customToggleWishlistItem,
    originalId,
    prices,
    inShoppingCart,
    hideWishList,
    canEnroll,
    isMobileCard,
    courseTag,
    metaDescription,
    dark,
    beforePreview,
  } = props;
  const isInWishlist = wishlistState.items.find(
    el => el.originalId === originalId,
  );
  const handleToggleWishlistItem =
    customToggleWishlistItem || toggleWishlistItem;
  const itsFree = prices && prices.price === 0;
  const showWishlistMobile = isMobileCard ? !courseTag : true;
  const renderWishlist =
    !inShoppingCart &&
    !itsFree &&
    !hideWishList &&
    !canEnroll &&
    showWishlistMobile;

  const onClickHandler = e => {
    e.preventDefault();

    if (beforePreview) {
      beforePreview();
    }
    setTimeout(() => {
      if (clickTitleHandler) {
        setTimeout(() => clickTitleHandler(), 0);
      } else if (url) {
        userActivity.track(
          userActivity.EVENTS.CLICK,
          {
            item_id: originalId,
            item_name: `TitleCourseCardV3, ${title}`,
            item_type: 'course',
            item_path: location.pathname,
          },
          url,
        );
      }
    }, 0);
  };

  return (
    <div
      className="TitleComponent flex justify-between"
      css={`
        .course-title {
          width: ${renderWishlist ? 'calc(100% - 24px)' : '100%'};
        }
        @media (min-width: 1024px) {
          min-height: 40px;
        }
      `}
    >
      <a
        href={url || ''}
        className="block whitespace-normal course-title text-left"
        onClick={e => onClickHandler(e)}
        data-cy="course-title"
      >
        <Text
          as="h2"
          type="subtitle3"
          className="TitleComponentText sm:mb-0 min-h-40"
          color={dark ? 'white' : 'base-main'}
        >
          <MultiClamp ellipsis="..." clamp={2} disableCssClamp>
            {title}
          </MultiClamp>
        </Text>
      </a>
      {renderWishlist && (
        <div
          className="w-20 h-20 ml-8 flex cursor-pointer items-center justify-center scale-in-hover hover-heart"
          onClick={() => handleToggleWishlistItem(props)}
          onKeyPress={() => handleToggleWishlistItem(props)}
          css={`
            ${isInWishlist &&
              `
              svg path {
                fill: ${secondaryMain};
              },
            `}
          `}
        >
          <HeartBorderLight size={17} color={secondaryMain} />
        </div>
      )}
      {metaDescription && <div className="hidden">{metaDescription}</div>}
    </div>
  );
};

export default Title;
